import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UsersGroupService } from './usersGroup.service';
import { UsersGroupComponent } from './usersGroup.component';
import { GroupDataService } from '../groupsData/groupData.service';
import {UserService } from '../userData/user.service';
import { SharedModule } from '../../shared/shared.module';
import { BlocksModule } from '../../blocks/blocks.module';
import { AddUsersGroupComponent } from './add-users-group.component';
import { AddUserGroupPopupComponent } from './add-user-group-popup/add-user-group-popup.component';

@NgModule({
    imports: [
        SharedModule,
        CommonModule,
        BlocksModule
    ],
    declarations: [
        UsersGroupComponent,
        AddUsersGroupComponent,
        AddUserGroupPopupComponent
    ],
    providers: [
        UsersGroupService,
        UserService,
        GroupDataService
    ],
    exports: [
        UsersGroupComponent,
        AddUsersGroupComponent,
        AddUserGroupPopupComponent
    ]
})
export class UsersGroupsComponent { }
